// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1945":"d5f0f127cbd2df79","6901":"efe14085ad826905"}[chunkId] + ".css";
};